import parse, { domToReact } from 'html-react-parser';
import React, { Fragment } from 'react';

import { REGEX_PHONE_NUMBER, REGEX_URL } from './constants';
import { splitByPhoneNumber, splitByURL } from './utils';

import { openLink } from '@utils/common';
import { DefaultUrlComponent } from './DefaultUrl';
import { APP_BASE_PATH, SHARE_BASE_URL } from '@variables';
import { useAppNavigation } from '@hooks/appNavigation';

const hasUrl = (text: string) => {
  return REGEX_URL.test(text);
};

const linkify = (text: string, Component = DefaultUrlComponent) => {
  const dataArray = splitByURL(text);
  const result = dataArray.map((el, index) => {
    const isUrl = REGEX_URL.test(el);
    if (isUrl) {
      return <Component key={`url${index}`} url={el} />;
    }

    const innerDataArray = splitByPhoneNumber(el);
    if (innerDataArray.length > 0) {
      const returnValue = innerDataArray.map((item, index) => {
        const isPhoneNumber = REGEX_PHONE_NUMBER.test(item);
        if (isPhoneNumber) {
          const phoneNumberLink = `tel:///${el.replace(' ', '').replace('-', '').replace('.', '')}`;
          return <Component key={`inner_phone_number${index}`} url={phoneNumberLink} text={item} />;
        } else {
          return <Fragment key={`inner_text${index}`}>{item}</Fragment>;
        }
      });
      return returnValue;
    }

    return <Fragment key={`text${index}`}>{el}</Fragment>;
  });

  return result;
};

interface LinkifyProps {
  children?: string;
  style?: any;
}

const Linkify: React.FC<LinkifyProps> = ({ style, children }) => {
  const appNavigation = useAppNavigation();
  const text = `${children}` || '';
  const hasHtml = /<\/?[a-z][\s\S]*>/i.test(text);
  const hasSpecialChar = /&\/?[a-z]*;/i.test(text);
  if (hasHtml || hasSpecialChar) {
    return (
      <div style={style}>
        {parse(text, {
          replace: (domNode: any) => {
            if (domNode.attribs && domNode.attribs['data-link']) {
              const className = domNode.attribs.class;
              const link = domNode.attribs['data-link'];
              return (
                <div
                  title={link}
                  className={className}
                  onClick={() => {
                    const internalPath = link
                      .replace(`${SHARE_BASE_URL}/uc`, `${APP_BASE_PATH}lounge`)
                      .replace(`${SHARE_BASE_URL}/c`, `${APP_BASE_PATH}collection`)
                      .replace(`${SHARE_BASE_URL}/p`, `${APP_BASE_PATH}partner`)
                      .replace(`${SHARE_BASE_URL}`, `${APP_BASE_PATH}product`)
                      .replace(`${SHARE_BASE_URL}`, `${APP_BASE_PATH}product`)
                      .replace(`${window.location.protocol}://${window.location.host}`, '');
                    if (!internalPath.startsWith('http')) {
                      appNavigation.to(internalPath);
                      return;
                    }

                    openLink(link);
                  }}>
                  {domToReact(domNode.children)}
                </div>
              );
            }
            return;
          },
        })}
      </div>
    );
  }

  return <div style={style}>{linkify(text)}</div>;
};

export { hasUrl, Linkify, linkify };
